/**
 * Gera um array de anos para uso em selects/dropdowns
 * @param {Object} options - Opções de configuração
 * @param {number} options.yearsBack - Quantidade de anos passados a incluir (padrão: 8)
 * @param {number} options.yearsForward - Quantidade de anos futuros a incluir (padrão: 1)
 * @param {number} options.startYear - Ano inicial fixo (opcional, sobrescreve yearsBack/yearsForward)
 * @param {number} options.endYear - Ano final fixo (opcional, sobrescreve yearsBack/yearsForward)
 * @returns {Array} Array de objetos com formato { value: string, label: string }
 * 
 * @example
 * // Padrão: 1 ano futuro + ano atual + 7 anos passados (total: 9 anos)
 * const years = generateYearOptions();
 * 
 * @example
 * // Personalizado: 3 anos futuros + ano atual + 4 anos passados (total: 8 anos)
 * const years = generateYearOptions({ yearsForward: 3, yearsBack: 5 });
 * 
 * @example
 * // Apenas anos passados: ano atual + 5 anos passados (total: 6 anos)
 * const years = generateYearOptions({ yearsBack: 6, yearsForward: 0 });
 * 
 * @example
 * // Range fixo: de 2017 até ano atual + 3
 * const currentYear = new Date().getFullYear();
 * const years = generateYearOptions({ startYear: 2017, endYear: currentYear + 3 });
 */
export const generateYearOptions = (options = {}) => {
	const {
		yearsBack = 8,
		yearsForward = 1,
		startYear,
		endYear,
	} = options;

	const currentYear = new Date().getFullYear();

	// Se startYear e endYear foram fornecidos, usa range fixo
	if (startYear !== undefined && endYear !== undefined) {
		const years = [];
		for (let i = startYear; i <= endYear; i++) {
			years.push({ value: i.toString(), label: i.toString() });
		}
		return years;
	}

	// Caso contrário, usa a lógica de anos passados/futuros
	const totalYears = yearsBack + yearsForward;
	const years = Array.from({ length: totalYears }, (_, index) => {
		const year = currentYear + (yearsForward - index);
		return { value: year.toString(), label: year.toString() };
	});

	return years;
};

